import {Section} from 'interfaces/Project';

export default function getTrayName(section: Section): string {
  if (section.tray === null) {
    return '';
  }
  const length = 3 * Math.ceil(section.length / 3);
  return `${section.tray.clientReference} - ${section.tray.name} (${length} metros)`;
}
